<template lang="pug">
.reset_password
  .bg-light
    .container.py-5
      .row.justify-content-center.py-5.register
        .col-md-5
          h3.py-2 Reset Password :
          form
            .form-row
              .form-group.col-md-12
                label(for="exampleInputPassword1")
                  | New Password
                  span.text-danger *
                  font-awesome-icon.ml-1(
                    v-b-tooltip.hover.right="passwordRule",
                    :icon="['fas', 'exclamation-circle']"
                  ) 
                input#exampleInputPassword1.form-control(
                  type="password",
                  v-model="password",
                  :class="{ 'is-invalid': passwordCheck }"
                )
                #validationServer03Feedback.invalid-feedback
                  | Please fill in the correct Password.
              .form-group.col-md-12
                label(for="exampleInputPassword2")
                  | Confirm New Password
                  span.text-danger *
                input#exampleInputPassword2.form-control(
                  type="password",
                  v-model="confirmPassword",
                  :class="{ 'is-invalid': confirmPasswordCheck }"
                )
                #validationServer03Feedback.invalid-feedback
                  | Please fill in the correct Password.
            .form-group
              button.btn.btn-warning.px-4(
                type="button",
                @click="resetPassword"
              ) Send

  float-actions
  float-top
  .PCAP-IC-selector.d-block.d-sm-none
    a.shadow-sm(
      v-b-modal.dialog="",
      @click="$bvModal.show('selectorModal')",
      data-toggle="modal",
      data-target="#selectorModal"
    )
      font-awesome-icon.i_mr_1(:icon="['fas', 'search']") 
      | PCAP IC selector
  custom-footer
</template>

<script>
import Footer from "@/components/home/Footer";
import FloatTop from "@/components/common/FloatTop";
import FloatActions from "@/components/common/FloatActions";
import { validStringEmpty } from "@/utils/validate";
import { resetPasswordConfirm } from "@/api/user";

export default {
  name: "ResetPassword",
  metaInfo() {
    return {
      title: this.metaData.title,
    };
  },
  components: {
    "custom-footer": Footer,
    "float-top": FloatTop,
    "float-actions": FloatActions,
  },
  data() {
    return {
      password: "",
      confirmPassword: "",
      passwordCheck: false,
      passwordRule:
        "Your password must be between & and 15 characters long wish at least one letter of the alphabet and one digit. Special characters (#,&,%,*,etc.) are not supported.",
      confirmPasswordCheck: false,

      metaData: {
        title: "Reset Password ｜Welcome to EETI Service World ",
      },
    };
  },
  created() {
    if (!this.$route.query.user || !this.$route.query.token) {
      this.$router.push({ name: "Home" });
    }
  },
  methods: {
    resetPassword() {
      if (validStringEmpty(this.password)) {
        this.passwordCheck = true;
      } else {
        this.passwordCheck = false;
      }
      if (validStringEmpty(this.confirmPassword)) {
        this.confirmPasswordCheck = true;
      } else {
        this.confirmPasswordCheck = false;
      }
      if (
        !this.confirmPasswordCheck &&
        this.password !== this.confirmPassword
      ) {
        this.confirmPasswordCheck = true;
      }
      if (this.passwordCheck || this.confirmPasswordCheck) {
        return;
      }

      let inputData = {
        uid: this.$route.query.user,
        token: this.$route.query.token,
        new_password: this.password,
      };
      resetPasswordConfirm(inputData)
        .then(() => {
          this.resetInputData();
          alert("reset password success");
          this.$router.push({ name: "Login" });
        })
        .catch((error) => {
          alert(error.response.data.error_msg);
        });
    },
    resetInputData() {
      this.password = "";
      this.confirmPassword = "";
    },
  },
};
</script>
<style lang="scss" scoped>
.bg-light {
  background-color: #eee;
}
</style>
